<script lang="ts" setup>
import { useModal } from 'vue-final-modal'

import Dolyame from '~/components/modal-windows/Dolyame.vue'
import helpers from '~/helpers'

const props = withDefaults(
  defineProps<{
    price: number
    isWideOnMobile?: boolean
  }>(),
  { isWideOnMobile: false }
)

const installmentsCount = 4
const minPrice = 4
const maxPrice = 30000

const enableButton = computed(() => props.price >= minPrice && props.price <= maxPrice)
const equalPaymentAmount = computed(() => Math.floor(props.price / installmentsCount))

async function openDolyameModalWindow (): Promise<void> {
  await useModal({ component: Dolyame, attrs: { price: props.price } }).open()
}
</script>

<template>
  <button
    v-if="enableButton"
    class="dolyame-button flex items-center justify-center bg-transparent"
    :class="{ 'dolyame-button_wide-on-mobile': isWideOnMobile }"
    @click="openDolyameModalWindow"
  >
    <SvgIcon class="dolyame-button__dolyame-white-icon" name="payment-methods/dolyame-white" />
    {{ installmentsCount }}&nbsp;платежа по&nbsp;{{ helpers.formatPrice(equalPaymentAmount) }}&nbsp;₽
    <SvgIcon class="dolyame-button__navigate-next-icon" name="outlined/navigate-next" />
  </button>
</template>

<style lang="scss" scoped>
@use 'assets/css/variables';

.dolyame-button {
  border: 1px solid variables.$main-light-gray-color;
  border-radius: 12px;
  box-sizing: border-box;
  color: variables.$main-gray-color;
  font-family: inherit;
  font-size: 16px;
  font-weight: 500;
  height: 40px;
  line-height: 20px;
  outline: none;
  padding: 10px 16px;

  &:hover {
    cursor: pointer;
  }

  &_wide-on-mobile {
    @media screen and (max-width: 480px) {
      width: 100% !important;
    }
  }

  &__dolyame-white-icon {
    height: 20px;
    margin-right: 8px;
    width: 64px;
  }

  &__navigate-next-icon {
    font-size: 20px;
    margin-left: 8px;
  }
}
</style>
